import { Label } from "./ui/label"
import { Switch } from "./ui/switch"
import { clsx } from "./utils"

export function ToggleButton(input: {
  checked: boolean
  label: string
  onChange: ()=> void
}) {
  return (
    <div className="flex items-center space-x-2" onClick={input.onChange}>
      <Switch id={input.label} />
      <Label
        className={clsx({
          "line-through": !input.checked,
        })}
        htmlFor={input.label}
      >
        {input.label}
      </Label>
    </div>
  )
}
